import React, { useState } from 'react';

import { bool, func, number, shape, string } from 'prop-types';

import Button from 'components/Common/Buttons/ButtonV3';

import Flexbox from 'components/Common/Flexbox';
import Text from 'components/Common/Text';

import TextInput from 'components/Common/TextInput';

const FreeResponseInput = ({
  contextId,
  handleDeleteResponse,
  error,
  handleSaveResponse,
  initialValue,
  prompt,
  responseId,
  setManualClose,
}) => {
  const [response, setResponse] = useState(initialValue);

  const handleSubmit = e => {
    e.stopPropagation();
    e.preventDefault();
    if (response) {
      handleSaveResponse({ value: response, prompt, isText: true });
    } else {
      handleDeleteResponse({ promptId: prompt.id, contextId, responseId });
    }
    setManualClose(true);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Text variant="titleMdBold" mb={1.5}>
        {prompt.text}
      </Text>
      <TextInput
        error={error}
        fullWidth
        multiline
        onChange={e => setResponse(e.target.value)}
        rows={3}
        value={response}
      />
      <Flexbox justifyContent="flex-end" gap={2} mt={1.5}>
        <Button
          color="gray"
          label="Cancel"
          onClick={e => {
            e.stopPropagation();
            setManualClose(true);
          }}
          size="small"
          variant="text"
        />
        <Button
          label="Save"
          size="small"
          onClick={handleSubmit}
          type="submit"
          variant="filled"
        />
      </Flexbox>
    </form>
  );
};

FreeResponseInput.propTypes = {
  contextId: number,
  error: bool,
  handleDeleteResponse: func.isRequired,
  handleSaveResponse: func.isRequired,
  initialValue: string,
  prompt: shape({}).isRequired,
  setManualClose: func.isRequired,
  responseId: number,
};

FreeResponseInput.defaultProps = {
  contextId: undefined,
  error: false,
  initialValue: '',
  responseId: undefined,
};

export default FreeResponseInput;
